<template>
  <MainLayout selectMenu="1-1">
    <WebSocket :url="webSocketUrl" @receive-message="receiveMessage"></WebSocket>
    <!-- 操作栏区域 -->
    <Row class="dashboard-toolbar menu-actions">
      <Col flex="2">
      <Button :type="openState ? 'default' : 'primary'" :icon="openState ? 'md-contract' : 'md-expand'"
        @click="revert()" class="btn-toggle" size="small">
        {{ openStateMap[openState] }}
      </Button>
      </Col>
      <Col flex="2" class="action">
      <div class="device-status-cards">
        <div class="device-status-card">
          <div class="device-icon">
            <Icon type="md-desktop" size="18" />
          </div>
          <div class="device-info">
            <div class="device-count">{{ deviceStats.total }}</div>
            <div class="device-label">{{ getTranslation("m089") }}</div>
          </div>
        </div>
        <div class="device-status-card">
          <div class="device-icon">
            <Icon type="md-checkmark-circle" size="18" color="#52c41a" />
          </div>
          <div class="device-info">
            <div class="device-count">{{ deviceStats.online }}</div>
            <div class="device-label">{{ getTranslation("m131") }}</div>
          </div>
        </div>
        <div class="device-status-card">
          <div class="device-icon">
            <Icon type="md-close-circle" size="18" color="#ff4d4f" />
          </div>
          <div class="device-info">
            <div class="device-count">{{ deviceStats.offline }}</div>
            <div class="device-label">{{ getTranslation("m132") }}</div>
          </div>
        </div>
        <div class="device-status-card">
          <div class="device-icon">
            <Icon type="md-refresh-circle" size="18" color="#fa8c16" />
          </div>
          <div class="device-info">
            <div class="device-count">{{ deviceStats.reconnect }}</div>
            <div class="device-label">{{ getTranslation("m133") }}</div>
          </div>
        </div>
      </div>
      </Col>
      <Col flex="2" class="flex-right">
      <Input v-model="searchKey" :placeholder="getTranslation('m134')" @on-enter="search"
        style="width: 150px; margin-right: 10px;" />
        <Tooltip :content="getTranslation('k176')" placement="bottom" theme ="light" :transfer="true">
      <Button type="primary" size="small" @click.native="search()" shape="circle" icon="ios-search"></Button>
      </Tooltip>&nbsp;
      <Tooltip :content="getTranslation('e020')" placement="bottom" theme ="light" :transfer="true">
      <Button type="error" size="small" @click.native="emptyQuery()" shape="circle" icon="ios-refresh"></Button>
      </Tooltip>&nbsp;
      <Button type="success" size="small" icon="md-link" @click.native="allOnline" :loading="allOnlineLoading">{{
        getTranslation("m076") }}</Button>&nbsp;
      <Button type="warning" size="small" icon="md-power" @click.native="allOffline" :loading="allOfflineLoading">{{ getTranslation("m077")
        }}</Button></Col>
    </Row>
    <template v-if="filteredProductlineAndMachine.length == 0 && searchKey.trim() != ''">
      <div style="text-align: center; margin-top: 50px; color: #888;">
        <Icon type="md-information-circle" size="36" style="margin-bottom: 10px;" />
        <div style="font-size: 16px;">{{ getTranslation("m135") }}</div>
      </div>
    </template>
    <Collapse v-model="openProductLine" class="custom-collapse" @on-change="changeOpen">
      <Panel :name="toString(item.id)" v-for="(item) in filteredProductlineAndMachine" :key="item.id"
        class="custom-collapse-item">
        {{ item.name }}<span class="dashboard-machine-count" v-html="calOnlineMachineCount[item.id]"></span><span 
        class="panel-action-part"><Button type="success" size="small" icon="md-link" @click.native.stop="LineOnline(item.id)" :loading="LineOnlineLoading[item.id]">{{
        getTranslation("m217") }}</Button>&nbsp;
      <Button type="warning" size="small" icon="md-power" @click.native.stop="LineOffline(item.id)" 
      :loading="LineOfflineLoading[item.id]">{{ getTranslation("m216")
        }}</Button></span>
        <div slot="content" class="machine-card-container menu-actions">
          <Card v-for="(machine) in item.machines" :key="machine.id" :class="['machine-card', calTitle[machine.id], { 'last-view-machine-card': machine.id === lastViewMachine }]"
            @click.native="goRunning(machine)">
            <!-- 角标：最后访问设备 -->
            <div v-if="machine.id === lastViewMachine" class="last-view-corner">
              <Icon type="md-star" size="14" class="last-view-star" />
            </div>
            <template v-if="machine.state != 1 && machine.state != 4">
              <div slot="title" class="title-desc">{{ stateMap[machine.state] }}</div>
            </template>
            <template v-if="machine.state == 1 || machine.state == 4">
              <div slot="title" class="title-desc">
                <div class="title-content">
                  <div class="state-desc">{{ stateMap[machine.state] }}</div>
                  <template v-if="warnList[machine.id] && warnList[machine.id].length > 0">
                    <div class="warn-badge">{{ getTranslation("l005") }}</div>
                  </template>
                </div>
              </div>
            </template>
            <div>{{ machine.name }}</div>
            <div :class="{'table-row-odd': machine.id !== lastViewMachine}">{{ machine.code }}</div>
            <div v-if="showIPAddress(machine)">{{ machine.address }}</div>
            <template v-if="showIPAddress(machine)">
            <div v-if="machine.state != 1 && machine.state != 4"  @click.stop.prevent="online(machine.id)"  ><Button type="primary" icon="md-link" size="small" style="width:100%" :loading="OnMachineLoading[machine.id]">{{ getTranslation("l002") }}</Button></div>
            <div v-else><Button type="warning" @click.stop.prevent="offline(machine.id)" icon="md-power" size="small" style="width: 100%;" class="off-line-button" :loading="OnMachineLoading[machine.id]">{{ getTranslation("z006") }}</Button></div>
            </template>
            <div v-if="!showIPAddress(machine) && tcpStateData[machine.id]">
              <div>{{ getTranslation("b006") }}:{{ tcpStateData[machine.id]["library"] }}</div>
              <div>{{ getTranslation("c023") }}:{{ tcpStateData[machine.id]["calOk"] }}&nbsp;&nbsp;{{ getTranslation("c024") }}:{{ tcpStateData[machine.id]["calNg"] }}</div>              
              <div>{{ getTranslation("c025") }}:{{tcpStateData[machine.id]["calOk"] + tcpStateData[machine.id]["calNg"] }}&nbsp;&nbsp;{{ MapRs(tcpStateData[machine.id]["rs"]) }}</div>
            </div>
          </Card>
        </div>
      </Panel>
    </Collapse>
  </MainLayout>
</template>

<script>
import { mapGetters } from 'vuex'
import MainLayout from '@/components/MainLayout.vue'
import { API_URL } from '@/constants/const.js'
import axios from 'axios';
import { Collapse, Panel, Card, Button, Row, Col, Icon, Input,Tooltip } from 'view-design';
import { postJsError ,KindOf670Series} from '@/util/util.js'
import WebSocket from '@/components/WebSocket.vue';
export default {
  name: 'DashboardIndex', // 组件名称
   components: {
    MainLayout, Collapse, Panel, Card, Button, Row, Col, WebSocket, Icon, Input,Tooltip
  },
  computed: {
    ...mapGetters(['getTranslation']),
    stateMap() {
      return {
        0: this.getTranslation("m036"),
        1: this.getTranslation("m035"),
        2: this.getTranslation("m003"),
        3: this.getTranslation("l005"),
        4: this.getTranslation("z040"),
      }
    },
    calTitle() {
      let rs = {}
      this.productlineAndMachine.forEach((item) => {
        item.machines && item.machines.forEach((oneMachine) => {
          rs[oneMachine.id] = '';
          if (oneMachine.state == 1) {
            rs[oneMachine.id] = 'title-online'
          } else if (oneMachine.state == 4) {
            rs[oneMachine.id] = 'title-reconnect'
          } else {
            rs[oneMachine.id] = 'title-offline'
          }
          if (this.warnList[oneMachine.id] && this.warnList[oneMachine.id].length > 0) {
            rs[oneMachine.id] = 'title-warn'
          }

        })
      })
      return rs;
    },
    openStateMap() {
      return {
        0: this.getTranslation("l011"),
        1: this.getTranslation("l010"),
      }
    },
    filteredProductlineAndMachine() {
      if (this.productlineAndMachine) {
        return this.productlineAndMachine.filter(item => item.machines && item.machines.length > 0);
      } else {
        return []
      }
    },
    calOnlineMachineCount() {
      let rs = {}
      this.productlineAndMachine.forEach((item) => {
        let onLineCount = 0;
        let totalCount = 0;
        let reconnectCount = 0;
        let offlineCount = 0;
        let warnCount = 0;
        item.machines && item.machines.forEach((oneMachine) => {
          if (oneMachine.state == 1) {
            onLineCount += 1
          } else if (oneMachine.state == 4) {
            reconnectCount += 1
          } else {
            offlineCount += 1
          }
          if (this.warnList[oneMachine.id] && this.warnList[oneMachine.id].length > 0) {
            warnCount += 1
          }
          totalCount += 1
        })
        rs[item.id] = `<span class="count-cal">` + this.getTranslation("m089") + `:<span class="count-total">${totalCount}</span>
          &nbsp;|&nbsp; `+ this.getTranslation("m035") + `：<span class="count-online">${onLineCount}</span>
          &nbsp;|&nbsp;`+ this.getTranslation("m036") + `：<span class="count-offline">${offlineCount}</span>`;
        rs[item.id] += `&nbsp;|&nbsp;` + this.getTranslation("m090") + `：<span class="count-reconnect">${reconnectCount}</span>`;
        if (warnCount > 0) {
          rs[item.id] += `&nbsp;|&nbsp;` + this.getTranslation("l005") + `：<span class="count-warn" style="color:#ff4d4f;">${warnCount}</span>`;
        }
        rs[item.id] += `</span>`;
      })
      return rs;
    },
    deviceStats() {
      let totalCount = 0;
      let onlineCount = 0;
      let reconnectCount = 0;
      let offlineCount = 0;

      this.productlineAndMachine.forEach((item) => {
        item.machines && item.machines.forEach((oneMachine) => {
          totalCount += 1;
          if (oneMachine.state == 1) {
            onlineCount += 1;
          } else if (oneMachine.state == 4) {
            reconnectCount += 1;
          } else {
            offlineCount += 1;
          }
        });
      });

      return {
        total: totalCount,
        online: onlineCount,
        reconnect: reconnectCount,
        offline: offlineCount
      };
    },
    webSocketUrl() {
      return API_URL['webSocket'];
    },
    
  },
  data() {
    return {
      productlineAndMachine: [],
      openProductLine: [],
      origialProductlineAndMachine: [],
      openState: 1,//1为展示了
      warnList: {},
      searchKey: '',
      lastViewMachine: 0,
      tcpStateData: {},
      setting:{},
      canOpen:{},
      allOnlineLoading:false,
      allOfflineLoading:false,
      LineOnlineLoading:{},
      LineOfflineLoading:{},
      OnMachineLoading:{},
    }
  },
 
  mounted() {
    this.$store.commit('setBreadcrumbItems', [
      { title: this.getTranslation('l001') }
    ])
  },
  created() {
    this.initLastView();    
    this.getData();
  },
  methods: {
    initLastView() {
      const v = parseInt(localStorage.getItem('dashboard.lastViewMachine') || '0', 10);
      this.lastViewMachine = isNaN(v) ? 0 : v;
    },
    getData() {
      this.getSetting();
      let url = API_URL["productlineGetWithMachine"];
      axios.get(url,{ timeout: 300000 })
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.productlineAndMachine = res.data.data;
            this.origialProductlineAndMachine = this.productlineAndMachine
            if (this.productlineAndMachine) {
              // 设置默认全部展开 - 将所有产品线ID设置为展开状态
              this.openProductLine = this.productlineAndMachine
                .filter(item => item.machines && item.machines.length > 0)
                .map(item => item.id.toString());
              this.mergeOpen();
            }
            if (this.searchKey && this.searchKey.trim() !== '') {
              this.search();
            }
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          } else {
            this.$Message.error(this.getTranslation('c001'));
          }
        })
        .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
    },
    getSetting(){      
      let url = API_URL["settingGet"];
      axios.get(url)
        .then(res => {
          if (res && res.data && res.data.code == 200) {
            this.setting = res.data.data.setting || {};
          }
        })
        .catch((err) => {
          postJsError(err)
        })

    },
    mergeOpen() {
      let locValue = localStorage.getItem('dashboard.prodline.state')
      if (locValue !== null && locValue !== undefined) {
        var pLineState = JSON.parse(locValue || '[]');
        this.openProductLine = this.openProductLine
          .filter(item => pLineState.includes(item))
        localStorage.setItem('dashboard.prodline.state', JSON.stringify(this.openProductLine))
      } else {
        localStorage.setItem('dashboard.prodline.state', JSON.stringify(this.openProductLine))
      }
    },
    changeOpen(val) {
      this.openProductLine = val
      localStorage.setItem('dashboard.prodline.state', JSON.stringify(this.openProductLine))
    },
    toString(id) {
      return id.toString();
    },
    async online(id) {
      let url = API_URL["machineOnline"];
      let params = {
        id: id
      }
      this.$set(this.OnMachineLoading, id, true);
      let res = await axios.get(url, {
        params: params
      })
      .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
      if(res ){
          if (res && res.data && res.data.code == 200) {
            this.setMachineState(id, 1);
            this.$Message.success(res.data.msg);
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          } else {
            this.$Message.error(this.getTranslation('c001'));
          }
        }
      this.$set(this.OnMachineLoading, id, false);
    },
    async offline(id) {
      let url = API_URL["machineOffline"];
      let params = {
        id: id
      }
      this.$set(this.OnMachineLoading, id, true);
      let res = await axios.get(url, {
        params: params
      })
      .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
      if (res){
          if (res && res.data && res.data.code == 200) {
            this.setMachineState(id, 0);
            this.$Message.success(res.data.msg);
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          } else {
            this.$Message.error(this.getTranslation('c001'));
          }
        }
        this.$set(this.OnMachineLoading, id, false);
    },
    setMachineState(id, state) {
      this.productlineAndMachine.forEach((item) => {
        item.machines && item.machines.forEach((oneMachine) => {
          if (oneMachine.id == id) {
            this.$set(this.warnList, id, null);
            oneMachine.state = state
          }
        })
      })
    },
    revert() {
      if (this.openState == 1) {
        this.openProductLine = [];
        this.openState = 0;

      } else {
        this.openProductLine = this.filteredProductlineAndMachine
          .map(item => item.id.toString());
        this.$nextTick(() => {
          this.openState = 1;
        })
      }
      localStorage.setItem('dashboard.prodline.state', JSON.stringify(this.openProductLine))
    },
    async goRunning(machine) {
      if (KindOf670Series(machine.kind)) {
        
        if(this.canOpen[machine.id]===false){
            return ;
        } else {
          this.canOpen[machine.id] = false;
          let invokeUrl = API_URL["invokeExternalApp"] + '?code=' + machine.code;
          let res =await axios.get(invokeUrl)
          .catch((err) => {
            postJsError(err)
            this.$Message.error(this.getTranslation('c001'));
          })
          if (res && res.data && res.data.code == 200) {
            let lang = localStorage.getItem('system.lang') || 'zh-cn';
            lang = lang.replace('-', '');
            let url = "heron670://open?_-id-" + machine.code+"_-dir-"+this.setting["hrc670Dir"]+'_-lg-'+lang;
            window.location.href = url
            let saveUrl = API_URL["saveExternalApp"] + '?code=' + machine.code;
            axios.get(saveUrl)
              .catch((err) => {
                postJsError(err)
              })
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          }
          setTimeout(() => {
            this.canOpen[machine.id] = true;
          }, 2000);
        }

      } else {
        let urlPath = {
          path: '/middle',
          query: { mac: machine.id }
        };
        this.$router.push(urlPath)
      }

      //const url = this.$router.resolve(urlPath).href;
      //window.open(url, '_blank');
    },
    async allOnline() {
      this.allOnlineLoading = true;
      if (this.filteredProductlineAndMachine.length == 0) {
        this.$Message.info(this.getTranslation('m136'));
        this.allOnlineLoading = false;
        return;
      }
      let ids = '';
      this.filteredProductlineAndMachine.forEach((item) => {
        item.machines && item.machines.forEach((oneMachine) => {
          if (ids !== '') {
            ids += ',';
          }
          ids += oneMachine.id;
        })
      })
      let url = API_URL["machineAllOnline"] + '?ids=' + ids;
      let formData = new FormData();
      formData.append('ids', ids);
      let res = await axios.post(url, formData, { timeout: 300000 })
      .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
      if(res){
          this.getData();
          if (res && res.data && res.data.code == 200) {
            this.$Message.success(res.data.msg);
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          } else {
            this.$Message.error(this.getTranslation('c001'));
          }
        }
      this.allOnlineLoading = false;
        
    },
    async allOffline() {
      this.allOfflineLoading = true;
      if (this.filteredProductlineAndMachine.length == 0) {
        this.$Message.info(this.getTranslation('m136'));
        this.allOfflineLoading = false;
        return;
      }
      let ids = '';
      this.filteredProductlineAndMachine.forEach((item) => {
        item.machines && item.machines.forEach((oneMachine) => {
          if (ids !== '') {
            ids += ',';
          }
          ids += oneMachine.id;
        })
      })
      let url = API_URL["machineAllOffline"];
      let formData = new FormData();
      formData.append('ids', ids);
      let res = await axios.post(url, formData, { timeout: 300000 })
      .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })

        if (res){
          this.getData();
          if (res && res.data && res.data.code == 200) {
            this.$Message.success(res.data.msg);
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          } else {
            this.$Message.error(this.getTranslation('c001'));
          }
        }
        
        this.allOfflineLoading = false;
    },
    async LineOnline(pid) {
      this.$set(this.LineOnlineLoading, pid, true );
      if (this.filteredProductlineAndMachine.length == 0) {
        this.$Message.info(this.getTranslation('m136'));
        this.$set(this.LineOnlineLoading, pid, false );
        return;
      }
      let ids = '';
      this.filteredProductlineAndMachine.forEach((item) => {
        if (item.id == pid) {
          item.machines && item.machines.forEach((oneMachine) => {
            if (ids !== '') {
              ids += ',';
            }
            ids += oneMachine.id;
          })
        }
      })
      let url = API_URL["machineAllOnline"] + '?ids=' + ids;
      let formData = new FormData();
      formData.append('ids', ids);
      let res = await axios.post(url, formData, { timeout: 300000 })
       .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })

      if(res){
          this.getData();
          if (res && res.data && res.data.code == 200) {
            this.$Message.success(res.data.msg);
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          } else {
            this.$Message.error(this.getTranslation('c001'));
          }
        }
        this.$set(this.LineOnlineLoading, pid, false );
       
    },
    async LineOffline(pid) {
      this.$set(this.LineOfflineLoading, pid, true );
      if (this.filteredProductlineAndMachine.length == 0) {
        this.$Message.info(this.getTranslation('m136'));
        this.$set(this.LineOfflineLoading, pid, false );
        return;
      }
      let ids = '';
      this.filteredProductlineAndMachine.forEach((item) => {
        if (item.id == pid) {
          item.machines && item.machines.forEach((oneMachine) => {
            if (ids !== '') {
              ids += ',';
            }
            ids += oneMachine.id;
          })
        }
      })
      let url = API_URL["machineAllOffline"];
      let formData = new FormData();
      formData.append('ids', ids);
      let res = await axios.post(url, formData, { timeout: 300000 })
       .catch((err) => {
          postJsError(err)
          this.$Message.error(this.getTranslation('c001'));
        })
      if(res){
          this.getData();
          if (res && res.data && res.data.code == 200) {
            this.$Message.success(res.data.msg);
          } else if (res && res.data && res.data.msg) {
            this.$Message.error(res.data.msg);
          } else {
            this.$Message.error(this.getTranslation('c001'));
          }
        }
        
        this.$set(this.LineOfflineLoading, pid, false );
    },
    receiveMessage(obj) {
      if (obj && obj.kind) {
        switch (obj.kind) {
          case 'state':
            if (obj.data.offline === true) {
              this.setMachineState(obj.data.macId, 0)
            } else {
              if (obj.data.netState === 0) {
                this.setMachineState(obj.data.macId, 4)
              } else if (obj.data.netState === 1) {
                this.setMachineState(obj.data.macId, 1)
              }
            }
            break;
          case 'warnList':
            if (obj.data) {              
              if (obj.data.clear) {                
                this.$set(this.warnList, obj.data.macId, null);
              } else {
                this.$set(this.warnList, obj.data.macId, obj.data.alarms || []);
              }

            }
            break;
          case 'tcpState':
            if (obj.data.offline === true) {
              this.setMachineState(obj.data.macId, 0)
            } else {
              this.setMachineState(obj.data.macId, 1)
            }
            if (obj.data && obj.data.macId) {
              this.$set(this.tcpStateData, obj.data.macId, obj.data);
            }

            break;
          default:
            break;
        }
      }
    },
    search() {
      this.productlineAndMachine = JSON.parse(JSON.stringify(this.origialProductlineAndMachine))
      if (this.searchKey && this.searchKey.trim() !== '') {
        const key = this.searchKey.trim().toLowerCase();
        // 深拷贝原始数据，避免修改原始数据
        this.productlineAndMachine.forEach((item) => {
          if (!item.machines) {
            item.machines = [];
            return;
          }
          item.machines = item.machines.filter((machine) => {
            return machine.name.toLowerCase().includes(key) ||
              machine.code.toLowerCase().includes(key) ||
              machine.address.toLowerCase().includes(key);
          });
        });
      }
    },
    emptyQuery() {
      this.searchKey = '';
      this.productlineAndMachine = JSON.parse(JSON.stringify(this.origialProductlineAndMachine))
    },
    canConnect(machine) {
      if (KindOf670Series(machine.kind)) {
        return false;
      }
      return true
    },
    showIPAddress(machine) {
      if (KindOf670Series(machine.kind)) {
        return false;
      }
      return true;
    },
    MapRs(state) {
      if (state == 1) {
        return "OK"
      } else if (state == 2) {
        return "NG"
      }
    }
  }
}
</script>
<style>
.dashboard-machine-count .count-cal {
  color: #1890ff;
  font-size: 14px;
  background-color: #f0f8ff;
  padding: 0 10px;
  border-radius: 4px;
  margin-left: 10px;
  display: inline-block;
  line-height: 22px;
  vertical-align: middle;
  margin-top: 1px;
}

.dashboard-machine-count .count-total {
  color: #0958d9;
  font-weight: bold;
  font-size: 14px;
  background-color: #e6f7ff;
  padding: 2px 6px;
  margin: 0 2px;
}

.dashboard-machine-count .count-online {
  color: #08979c;
  font-weight: bold;
  font-size: 14px;
  background-color: #e6fffb;
  padding: 2px 6px;
  margin: 0 2px;
}

.dashboard-machine-count .count-offline {
  color: #a8071a;
  font-weight: bold;
  font-size: 14px;
  background-color: #fff1f0;
  padding: 2px 6px;
  margin: 0 2px;
}

.dashboard-machine-count .count-reconnect {
  color: #fa8c16;
  font-weight: bold;
  font-size: 14px;
  background-color: #fff7e6;
  padding: 2px 6px;
  margin: 0 2px;
}

.dashboard-machine-count .count-warn {
  color: #a8071a;
  font-weight: bold;
  font-size: 14px;
  background-color: #fff1f0;
  padding: 2px 6px;
  margin: 0 2px;
}

/* 确保折叠面板标题中的HTML内容正常显示 */
.custom-collapse-item .ivu-collapse-header {
  background-color: #597ef7;
  color: white;
  border-radius: 4px;

}

.custom-collapse-item:hover {
  transform: translateY(-2px);
}
</style>

<style scoped>
@import url('../../assets/style/list.css');

/* 折叠面板样式 */
.custom-collapse {
  border: none;
}

.custom-collapse-item {
  border: none;
  margin-bottom: 4px;
}

/* 面板标题行深色处理 - 调小高度与字体 */
.custom-collapse-item>>>.ivu-collapse-header {
  background-color: #597ef7;
  /* 偏紫色的蓝色，作为悬停色 */

  color: white;
  border-radius: 4px;
  padding: 2px 12px;
  /* 调小内边距以降低高度 */
  font-size: 12px;
  /* 调小字体以降低视觉高度 */
  line-height: 20px;
  /* 控制标题行高度 */
  height: 30px;
}

.custom-collapse-item>>>.ivu-collapse-header:hover {
  background-color: #4096ff;
  /* 中等深度的蓝色 */
}

.custom-collapse-item>>>.ivu-collapse-header i {
  color: white;
}

/* 面板内容区域 */
.custom-collapse-item>>>.ivu-collapse-content {
  background-color: #f5f5f5;
  border: none;
}

.custom-collapse-item>>>.ivu-collapse-content-box {
  padding: 16px;
}

.machine-card-container {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
  margin: -6px;
  cursor: pointer;
  align-items: flex-start;
}

.machine-card {
  width: 9.5%;
  margin: 0;
  border: 1px solid #bfbfbf;
  /* 加深外边框颜色 */
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.09);
  border-radius: 6px;
  overflow: hidden;
  transition: all 0.3s ease;
}

.machine-card:hover {
  border-color: #1890ff;
  /* 悬停时外边框颜色变化 */
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
  transform: translateY(-2px);
}

/* 卡片内部边框 */
.machine-card>>>.ivu-card {
  border: 5px solid #d9d9d9;
  /* 加深内边框颜色 */
  border-radius: 6px;
}

/* 卡片标题行背景色 */
.machine-card>>>.ivu-card-head {
  border-bottom: 1px solid #e8e8e8;
  font-weight: bold;
  height: 30px;
}

.machine-card>>>.ivu-card-head-title {
  font-weight: 500;
}


/* 卡片内容样式 */
.machine-card>>>.ivu-card-body {
  padding: 12px 12px;
}

.machine-card>>>.ivu-card-body div {
  margin-bottom: 4px;
  font-size: 12px;
  color: #595959;
  border-bottom: 1px solid #d9d9d9;
  /* 加深行间下边框颜色 */
  padding-bottom: 4px;
}

.machine-card>>>.ivu-card-body div:last-child {
  border-bottom: none;
  /* 最后一行去掉下边框 */
  padding-bottom: 0;
}

.machine-card>>>.ivu-card-body div:last-child {
  margin-bottom: 0;
}

.title-desc {
  margin-top: -5px;
}

.title-content {
  display: flex;
  justify-content: space-between;
  align-items: center;
  width: 100%;
}

.warn-badge {
  color: #ff4d4f;
  margin-top: -5px;
  background-color: #fff2f0;
  border: 1px solid #ffccc7;
  border-radius: 6px;
  padding: 4px 8px;
  font-size: 12px;
  font-weight: 500;
  white-space: nowrap;
  margin-left: 8px;
}

.title-offline>>>.ivu-card-head {
  background-color: #f0f2f5;
}

.title-online>>>.ivu-card-head {
  background-color: #39ff14;
}

.title-reconnect>>>.ivu-card-head {
  background-color: #f59e0b;
}


.title-warn>>>.ivu-card-head {
  background-color: #ff0000;
}

.title-offline>>>.ivu-card-head-title {
  color: #fff;
}

.title-online>>>.ivu-card-head-title {
  color: #262626;
}

.title-reconnect>>>.ivu-card-head-title {
  color: #ffffff;
}

.title-warn .state-desc {
  margin-top: -6px;
  color: #fff
}

/* 工具栏样式 */
.dashboard-toolbar {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 0;
  margin-bottom: 16px;
  border-bottom: 1px solid #e8e8e8;
  background-color: #fafafa;
  border-radius: 6px;
  padding: 12px 16px;
}


.btn-toggle {
  border-radius: 4px;
  font-weight: 400;
  transition: all 0.2s ease;
  min-width: 80px;
}

.btn-toggle:hover {
  transform: translateY(-1px);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.action {
  margin-top: -4px;
  display: flex;
  align-items: center;
  justify-items: center;
}

/* 操作按钮样式优化 */
.action .ivu-btn {
  font-weight: 500;
  border-radius: 4px;
  transition: all 0.2s ease;
  min-width: 60px;
  height: 29px;

}

/* 设备状态卡片样式 */
.device-status-cards {
  display: flex;
  gap: 12px;
  align-items: center;
  cursor: pointer;
}

.device-status-card {
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 8px 12px;
  background: #ffffff;
  border: 1px solid #e8e8e8;
  border-radius: 6px;
  box-shadow: 0 1px 4px rgba(0, 0, 0, 0.06);
  transition: all 0.3s ease;
  min-width: 110px;
}

.device-status-card:hover {
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.12);
  transform: translateY(-1px);
}

.device-icon {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 32px;
  height: 32px;
  background: #f5f5f5;
  border-radius: 6px;
  flex-shrink: 0;
}

.device-info {
  display: flex;
  flex-direction: column;
  align-items: flex-start;
}

.device-count {
  font-size: 16px;
  font-weight: 600;
  color: #262626;
  line-height: 1.2;
}

.device-label {
  font-size: 11px;
  color: #8c8c8c;
  line-height: 1.2;
  margin-top: 1px;
}

.device-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
}

.device-status {
  background-color: rgba(34, 197, 94, 0.15);
  color: #22c55e;
}

.device-name {
  display: flex;
  align-items: center;
  gap: 0.75rem;
}

.online-card .device-status {
  background-color: rgba(34, 197, 94, 0.15);
  color: #22c55e;
}

.device-status {
  display: flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.35rem 0.75rem;
  border-radius: 1rem;
  font-size: 0.875rem;
  font-weight: 500;
}

.status-online {
  background-color: #22c55e;
}

.status-indicator {
  width: 0.65rem;
  height: 0.65rem;
  border-radius: 50%;
  display: inline-block;
}

.stop-connect {
  width: 16px;
  height: 16px;
  vertical-align: middle;
}

/* 最后访问设备：呼吸发光动画 */
@keyframes lastViewPulseOnline {
  0%, 100% { box-shadow: 0 0 0 3px rgba(82, 196, 26, 0.25), 0 0 20px rgba(82, 196, 26, 0.18), 0 4px 12px rgba(0, 0, 0, 0.1); }
  50%      { box-shadow: 0 0 0 6px rgba(82, 196, 26, 0.12), 0 0 36px rgba(82, 196, 26, 0.32), 0 6px 20px rgba(0, 0, 0, 0.16); }
}
@keyframes lastViewPulseReconnect {
  0%, 100% { box-shadow: 0 0 0 3px rgba(250, 140, 22, 0.25), 0 0 20px rgba(250, 140, 22, 0.18), 0 4px 12px rgba(0, 0, 0, 0.1); }
  50%      { box-shadow: 0 0 0 6px rgba(250, 140, 22, 0.12), 0 0 36px rgba(250, 140, 22, 0.32), 0 6px 20px rgba(0, 0, 0, 0.16); }
}
@keyframes lastViewPulseOffline {
  0%, 100% { box-shadow: 0 0 0 3px rgba(140, 140, 140, 0.25), 0 0 20px rgba(140, 140, 140, 0.18), 0 4px 12px rgba(0, 0, 0, 0.1); }
  50%      { box-shadow: 0 0 0 6px rgba(140, 140, 140, 0.12), 0 0 36px rgba(140, 140, 140, 0.32), 0 6px 20px rgba(0, 0, 0, 0.16); }
}
@keyframes lastViewPulseWarn {
  0%, 100% { box-shadow: 0 0 0 3px rgba(255, 77, 79, 0.25), 0 0 20px rgba(255, 77, 79, 0.18), 0 4px 12px rgba(0, 0, 0, 0.1); }
  50%      { box-shadow: 0 0 0 6px rgba(255, 77, 79, 0.12), 0 0 36px rgba(255, 77, 79, 0.32), 0 6px 20px rgba(0, 0, 0, 0.16); }
}

/* 最后访问设备角标：右上角折叠丝带 */
.last-view-corner {
  position: absolute;
  top: -3px;
  right: -3px;
  width: 44px;
  height: 44px;
  clip-path: polygon(100% 0, 0 0, 100% 100%);
  z-index: 20;
  pointer-events: none;
  display: flex;
  align-items: flex-start;
  justify-content: flex-end;
}

.last-view-star {
  color: #fff;
  margin-top: 4px;
  margin-right: 4px;
  filter: drop-shadow(0 1px 2px rgba(0, 0, 0, 0.25));
}

/* 最后访问设备：卡片高亮（基础） */
.last-view-machine-card {
  border-width: 2px !important;
  border-style: solid !important;
  animation-duration: 2.5s;
  animation-timing-function: ease-in-out;
  animation-iteration-count: infinite;
  position: relative;
}

/* 按状态区分：在线（绿色系） */
.title-online.last-view-machine-card {
  background: linear-gradient(135deg, #d9f7be 0%, #f6ffed 50%, #d9f7be 100%) !important;
  border-color: #52c41a !important;
  animation-name: lastViewPulseOnline;
}
.title-online .last-view-corner {
  background: linear-gradient(135deg, #52c41a 0%, #389e0d 100%);
}

/* 按状态区分：重连（橙色系） */
.title-reconnect.last-view-machine-card {
  background: linear-gradient(135deg, #d9f7be 0%, #f6ffed 50%, #d9f7be 100%) !important;
  border-color: #52c41a !important;
  animation-name: lastViewPulseOnline;
}
.title-reconnect .last-view-corner {
  background: linear-gradient(135deg, #52c41a 0%, #389e0d 100%);
}

/* 按状态区分：离线（灰色系） */
.title-offline.last-view-machine-card {
  background: linear-gradient(135deg, #d9f7be 0%, #f6ffed 50%, #d9f7be 100%) !important;
  border-color: #52c41a !important;
  animation-name: lastViewPulseOnline;
}
.title-offline .last-view-corner {
  background: linear-gradient(135deg, #52c41a 0%, #389e0d 100%);
}

/* 按状态区分：告警（红色系） */
.title-warn.last-view-machine-card {
  background: linear-gradient(135deg, #d9f7be 0%, #f6ffed 50%, #d9f7be 100%) !important;
  border-color: #52c41a !important;
  animation-name: lastViewPulseOnline;
}
.title-warn .last-view-corner {
  background: linear-gradient(135deg, #52c41a 0%, #389e0d 100%);
}

/* 确保卡片容器相对定位以显示角标 */
.machine-card {
  position: relative;
}

.card-line {
  line-height: 15px;
}

.top-line {
  margin-top: -5px;
}
.panel-action-part{
  margin-right:5px;
  float:right;
}
</style>